
// // client/src/components/events/EventItemDetail.jsx
// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import ImageUploadModal from "../media/ImageUploadModal";
// import CameraComponent from "../media/CameraComponent";
// import AppFooter from "../AppFooter";
// import { useWebShare } from "../../hooks/useWebShare";
// import { FaCamera, FaUpload, FaTimes, FaPlus, FaShare, FaEnvelope, FaArrowLeft, FaTrash } from "react-icons/fa";
// import CommentsPanel from "../comments/CommentsPanel";
// import ToggleButtonGroup from "../ToggleButtonGroup";
// import { useMessagesUI } from "../../context/MessagesContext";
// import PostChoiceModal from "../media/PostChoiceModal";
// import AuctionConfig from "./AuctionConfig";
// import RaffleConfig from "./RaffleConfig";

// // ---- helpers kept in sync with EventCard ----
// const toAbs = (baseUrl, p) =>
//   !p ? p : /^https?:\/\//i.test(p) ? p : `${baseUrl}${p.startsWith("/") ? "" : "/"}${p}`;
// const isImage = (f) =>
//   (f?.mimetype?.startsWith?.("image/")) ||
//   /\.(png|jpe?g|gif|webp|svg|bmp)$/i.test(f?.path || f || "");
// const isVideo = (f) =>
//   (f?.mimetype?.startsWith?.("video/")) ||
//   /\.(mp4|mov|webm|ogg|avi|mkv)$/i.test(f?.path || f || "");

// // Video fix props for Safari/iOS
// const videoFixProps = {
//   playsInline: true,
//   preload: "metadata",
//   crossOrigin: "anonymous",
//   onLoadedMetadata: (e) => {
//     try {
//       if (e.currentTarget.currentTime === 0) e.currentTarget.currentTime = 0.1;
//     } catch {}
//   },
// };

// // ---- layout: match EventAdd ----
// const FORM_WIDTH = { maxWidth: 480, margin: "0 auto", padding: "0 12px" };
// const SELECT_INNER = {
//   width: "100%",
//   border: "none",
//   outline: "none",
//   background: "transparent",
//   minHeight: 120,
//   padding: "8px 10px",
// };

// const EventItemDetail = () => {
//   const [type, setType] = useState("default");
//   const [actionType, setActionType] = useState("default");
//   const [name, setName] = useState("");
//   const [description, setDescription] = useState("");
//   const [topSize, setTopSize] = useState([]);
//   const [bottomSize, setBottomSize] = useState([]);
//   const [shoeSize, setShoeSize] = useState([]);
//   const [files, setFiles] = useState([]);
//   const [registerStatus, setRegisterStatus] = useState("");
//   const [imagePath, setImagePath] = useState(null);
//   const [imagePaths, setImagePaths] = useState([]);
//   const [showCamera, setShowCamera] = useState(false);
//   const [isImageModalOpen, setIsImageModalOpen] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [newMessage, setNewMessage] = useState("");
//   const [statusMessage, setStatusMessage] = useState("");
//   const [postChoiceOpen, setPostChoiceOpen] = useState(false);
//   const [raffleLink, setRaffleLink] = useState("");
  
//   const [showAuctionConfig, setShowAuctionConfig] = useState(false);
//   const [showRaffleConfig, setShowRaffleConfig] = useState(false);

//   const [eventItem, setEventItem] = useState(null);
//   const [eventItemImages, setEventItemImages] = useState([]);
//   const [eventItemVideos, setEventItemVideos] = useState([]);
//   const [selectedMedia, setSelectedMedia] = useState({}); // { [url]: true }

//   const navigate = useNavigate();
//   const { tenant, eventId, itemId } = useParams();
//   const { share } = useWebShare();
//   const { openMessages } = useMessagesUI();

//   const baseUrl =
//     process.env.REACT_APP_BASE_URL ||
//     (typeof window !== "undefined" ? window.location.origin : "http://localhost:5000");

//   // unified media list
//   const rawItemFiles = [
//     ...(Array.isArray(eventItem?.files) ? eventItem.files : []),
//     ...(eventItemImages || []),
//     ...(eventItemVideos || []),
//   ].filter(Boolean);

//   const itemMedia = rawItemFiles
//     .map((f) => {
//       const path = f?.path || f?.url || f;
//       const video = isVideo(f) || isVideo(path);
//       return { url: toAbs(baseUrl, path), isVideo: !!video, _raw: f };
//     })
//     .filter((m, idx, arr) => arr.findIndex((x) => x.url === m.url) === idx);

//   // Count selected media
//   const selectedCount = Object.values(selectedMedia).filter(Boolean).length;

//   const pantSizes = [
//     { category: "M", range: "26 - 27", size: 26, label: "XXS" },
//     { category: "M", range: "27 - 28", size: 27, label: "XS" },
//     { category: "M", range: "28 - 29", size: 28, label: "XS" },
//     { category: "M", range: "29 - 30", size: 29, label: "S" },
//     { category: "M", range: "30 - 31", size: 30, label: "S" },
//     { category: "M", range: "31 - 32", size: 31, label: "M" },
//     { category: "M", range: "32 - 33", size: 32, label: "M" },
//     { category: "M", range: "33 - 34", size: 33, label: "M/L" },
//     { category: "M", range: "34 - 35", size: 34, label: "L" },
//     { category: "M", range: "35 - 36", size: 35, label: "L" },
//     { category: "M", range: "36 - 37", size: 36, label: "XL" },
//     { category: "M", range: "38 - 39", size: 38, label: "XL" },
//     { category: "M", range: "40 - 41", size: 40, label: "XXL" },
//     { category: "M", range: "42 - 43", size: 42, label: "XXL" },
//     { category: "M", range: "44 - 45", size: 44, label: "XXXL" },
//     { category: "M", range: "46 - 47", size: 46, label: "XXXL" },
//     { category: "M", range: "48 - 49", size: 48, label: "XXXL" },
//     { category: "M", range: "50 - 51", size: 50, label: "4XL" },
//     { category: "W", range: "23 - 25", size: "00", altSize: "23/24", label: "XXS" },
//     { category: "W", range: "25 - 26", size: "0", altSize: "25", label: "XXS" },
//     { category: "W", range: "26 - 27", size: "2", altSize: "26", label: "XS" },
//     { category: "W", range: "27 - 28", size: "4", altSize: "27", label: "XS" },
//     { category: "W", range: "28 - 29", size: "6", altSize: "28", label: "S" },
//     { category: "W", range: "29 - 30", size: "8", altSize: "29", label: "S" },
//     { category: "W", range: "30 - 31", size: "10", altSize: "30", label: "M" },
//     { category: "W", range: "31 - 32", size: "12", altSize: "31", label: "M" },
//     { category: "W", range: "32 - 33", size: "14", altSize: "32", label: "L" },
//     { category: "W", range: "33 - 34", size: "16", altSize: "33", label: "L" },
//     { category: "W", range: "34 - 35", size: "18", altSize: "34", label: "XL" },
//     { category: "W", range: "36 - 37", size: "20", altSize: "36", label: "XL" },
//     { category: "W", range: "38 - 39", size: "22", altSize: "38", label: "XXL" },
//     { category: "W", range: "40 - 41", size: "24", altSize: "40", label: "XXL" },
//   ];

//   const canCreateAction = ["raffle", "auction"].includes((actionType || "").toLowerCase());

//   const goToActionSetup = () => {
//     const act = (actionType || "").toLowerCase();
//     if (act === "auction") {
//       setShowAuctionConfig(true);
//     } else if (act === "raffle") {
//       setShowRaffleConfig(true);
//     }
//   };

//   // Load item + its media
//   useEffect(() => {
//     const fetchItemDetails = async () => {
//       try {
//         const [itemRes, imagesRes] = await Promise.all([
//           axios.get(`${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}`),
//           axios.get(`${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/images`),
//         ]);

//         const itemData = itemRes.data.item || {};
//         setEventItem(itemData);
//         setName(itemData.name || "");
//         setDescription(itemData.description || "");
//         setType(itemData.type || "default");

//         if (itemData.attributes) {
//           const top = itemData.attributes.filter((a) => a.attributename === "top_size").map((a) => a.attributevalue);
//           const bottom = itemData.attributes.filter((a) => a.attributename === "bottom_size").map((a) => a.attributevalue);
//           const shoes = itemData.attributes.filter((a) => a.attributename === "shoe_size").map((a) => a.attributevalue);
//           setTopSize(top);
//           setBottomSize(bottom);
//           setShoeSize(shoes);
//         }

//         setEventItemImages(imagesRes.data.images || []);

//         try {
//           const vidsRes = await axios.get(
//             `${baseUrl}/api/${tenant}/events/${eventId}/items/${itemId}/videos`
//           );
//           setEventItemVideos(vidsRes.data.videos || []);
//         } catch {
//           setEventItemVideos([]);
//         }
//       } catch (error) {
//         console.error("Error fetching event item details:", error);
//       }
//     };
//     fetchItemDetails();
//   }, [tenant, eventId, itemId, baseUrl]);

//   const handleImageCaptured = (capturedImage) => {
//     setImagePath(capturedImage);
//     setShowCamera(false);
//   };

//   const handleUploadComplete = async (files) => {
//     try {
//       if (files.length === 0) return;
//       setFiles(files);
//       setImagePath(URL.createObjectURL(files[0]));
//       setIsImageModalOpen(false);

//       const formData = new FormData();
//       formData.append("reftable", "t_event_item");
//       formData.append("tableid", itemId);
//       files.forEach((file) => formData.append("files", file));

//       try {
//         const response = await axios.post(
//           `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/uploadimage`,
//           formData,
//           { headers: { "Content-Type": "multipart/form-data" } }
//         );
//         if (response.data.success) {
//           const { data } = await axios.get(
//             `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/images`
//           );
//           setEventItemImages(data?.images || []);
//         }
//       } catch (error) {
//         console.error("❌ Error uploading images:", error);
//       }
//       setRegisterStatus("Files uploaded successfully!");
//     } catch (error) {
//       console.error("Error linking uploaded files:", error);
//     }
//   };

//   useEffect(() => {
//     document.body.classList.add("eventlist-fullbleed");
//     return () => document.body.classList.remove("eventlist-fullbleed");
//   }, []);

//   // Messages
//   useEffect(() => {
//     axios
//       .get(`${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/messages`)
//       .then((res) => setMessages(Array.isArray(res.data) ? res.data : res.data?.messages || []))
//       .catch((err) => console.error("Error loading messages:", err));
//   }, [tenant, eventId, itemId, baseUrl]);

//   const sendMessage = async () => {
//     if (!newMessage.trim()) return;
//     let currentUser = null;
//     try { currentUser = JSON.parse(localStorage.getItem("user")); } catch {}
//     const payload = { text: newMessage, senderId: currentUser?.id, username: currentUser?.username, email: currentUser?.email };
//     try {
//       const res = await axios.post(
//         `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/messages`,
//         payload
//       );
//       setMessages((m) => [...m, res.data]);
//       setNewMessage("");
//     } catch (err) {
//       console.error("Error sending message:", err);
//     }
//   };

//   const updateItem = async (e) => {
//     e.preventDefault();
//     try {
//       await axios.put(
//         `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}`,
//         { name, description, type, topSize, bottomSize, shoeSize }
//       );
//       navigate(`/${tenant}/${eventId}/eventDetail`);
//     } catch (err) {
//       console.error("Failed to update item:", err);
//     }
//   };

//   const handleCancel = () => navigate(`/${tenant}/events`);

//   /**
//    * Post ALL media (when no selection)
//    */
//   const handleCreateMediaPost = () => {
//     const toPublic = (p) => (p?.startsWith("/public/") ? p : p?.startsWith("/tenants/") ? `/public${p}` : p);
//     const cover = toPublic(eventItemImages?.[0]?.path || "");
//     navigate(`/${tenant}/${eventId}/${itemId}/mediaPost`, {
//       state: {
//         context: "event-item",
//         tenant,
//         eventId,
//         itemId,
//         title: name || "",
//         description: description || "",
//         image: cover,
//         images: (eventItemImages || []).map((i) => toPublic(i.path)),
//         videos: (eventItemVideos || []).map((v) => toPublic(v.path)),
//         item: eventItem,
//       },
//       replace: false,
//     });
//   };

//   /**
//    * Post ONLY selected media
//    */
//   const handlePostSelected = () => {
//     const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);
    
//     if (selectedUrls.length === 0) {
//       alert("Please select at least one media item to post.");
//       return;
//     }

//     const toPublic = (p) => (p?.startsWith("/public/") ? p : p?.startsWith("/tenants/") ? `/public${p}` : p);

//     const selectedImages = [];
//     const selectedVideos = [];

//     // Collect selected images
//     eventItemImages.forEach((img) => {
//       const url = toAbs(baseUrl, img.path || img.url || img);
//       if (selectedUrls.includes(url)) {
//         selectedImages.push(toPublic(img.path || img.url || img));
//       }
//     });

//     // Collect selected videos
//     eventItemVideos.forEach((vid) => {
//       const url = toAbs(baseUrl, vid.path || vid.url || vid);
//       if (selectedUrls.includes(url)) {
//         selectedVideos.push(toPublic(vid.path || vid.url || vid));
//       }
//     });

//     const cover = selectedImages[0] || "";

//     navigate(`/${tenant}/${eventId}/${itemId}/mediaPost`, {
//       state: {
//         context: "event-item",
//         tenant,
//         eventId,
//         itemId,
//         title: name || "",
//         description: description || "",
//         image: cover,
//         images: selectedImages,
//         videos: selectedVideos,
//         item: eventItem,
//       },
//       replace: false,
//     });
//   };

//   const toggleSelect = (url) =>
//     setSelectedMedia((prev) => ({ ...prev, [url]: !prev[url] }));

//   /**
//    * Delete single item media - WITH BACKEND INTEGRATION
//    */
//   const handleDeleteItemMedia = async (url) => {
//     if (!window.confirm("Delete this item media?")) return;
    
//     try {
//       // Call backend API to delete the item media
//       const response = await axios.delete(
//         `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/media/single`,
//         { data: { url } }
//       );

//       if (!response.data.success) {
//         throw new Error(response.data.message || 'Failed to delete item media');
//       }

//       // Update UI state after successful deletion
//       setEventItemImages((prev) => (prev || []).filter((x) => toAbs(baseUrl, x.path || x.url || x) !== url));
//       setEventItemVideos((prev) => (prev || []).filter((x) => toAbs(baseUrl, x.path || x.url || x) !== url));
//       setSelectedMedia((prev) => {
//         const n = { ...prev };
//         delete n[url];
//         return n;
//       });

//     } catch (error) {
//       console.error("Error deleting item media:", error);
//       alert(`Failed to delete item media: ${error.message || 'Unknown error'}. Please try again.`);
//     }
//   };

//   /**
//    * Delete selected media (batch) - WITH BACKEND INTEGRATION
//    */
//   const handleDeleteSelected = async () => {
//     const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);
    
//     if (selectedUrls.length === 0) {
//       alert("Please select at least one media item to delete.");
//       return;
//     }

//     if (!window.confirm(`Delete ${selectedUrls.length} selected media item(s)?`)) {
//       return;
//     }

//     try {
//       // Call backend API for batch deletion
//       const response = await axios.delete(
//         `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/media`,
//         { data: { urls: selectedUrls } }
//       );
      
//       if (!response.data.success) {
//         throw new Error(response.data.message || 'Failed to delete media');
//       }

//       // Update UI state after successful deletion
//       setEventItemImages((prev) => 
//         (prev || []).filter((x) => !selectedUrls.includes(toAbs(baseUrl, x.path || x.url || x)))
//       );
//       setEventItemVideos((prev) => 
//         (prev || []).filter((x) => !selectedUrls.includes(toAbs(baseUrl, x.path || x.url || x)))
//       );

//       // Clear selection
//       setSelectedMedia({});

//     } catch (error) {
//       console.error("Error deleting selected media:", error);
//       alert(`Failed to delete media: ${error.message || 'Unknown error'}. Please try again.`);
//     }
//   };

//   return (
//     <div className="container">
//       <h2 className="hdr hdr--primary hdr--lg">Event Item Detail</h2>

//       {/* Selected media count indicator */}
//       {selectedCount > 0 && (
//         <div
//           style={{
//             ...FORM_WIDTH,
//             padding: "8px 12px",
//             margin: "8px auto",
//             background: "#ff6800",
//             color: "white",
//             borderRadius: "8px",
//             fontSize: "14px",
//             fontWeight: "600",
//           }}
//         >
//           {selectedCount} media item{selectedCount !== 1 ? "s" : ""} selected
//         </div>
//       )}

//       {/* FORM — match EventAdd width */}
//       <form onSubmit={updateItem} style={FORM_WIDTH}>
//         <div className="form-group">
//           <label htmlFor="name">Name</label>
//           <input
//             id="name"
//             type="text"
//             className="form-control"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             placeholder="Enter item name"
//             required
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="description">Description</label>
//           <textarea
//             id="description"
//             className="form-control"
//             value={description}
//             onChange={(e) => setDescription(e.target.value)}
//             placeholder="Enter item description"
//           />
//         </div>

//         <div className="toggle-group">
//           <label className="block mb-2 font-semibold">Select Item Type:</label>
//           <ToggleButtonGroup
//             options={["default", "clothing", "shoes"]}
//             value={type}
//             onChange={setType}
//           />
//         </div>

//         {type === "clothing" && (
//           <>
//             <div className="form-group">
//               <label>Shirt Size:</label>
//               <div className="form-control" style={{ padding: 0 }}>
//                 <select
//                   multiple
//                   value={topSize}
//                   onChange={(e) =>
//                     setTopSize([...e.target.selectedOptions].map((o) => o.value))
//                   }
//                   style={SELECT_INNER}
//                 >
//                   {[
//                     "Extra Small",
//                     "Small",
//                     "Medium",
//                     "Large",
//                     "X-Large",
//                     "2X-Large",
//                     "3X-Large",
//                   ].map((s) => (
//                     <option key={s} value={s}>
//                       {s}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             <div className="form-group">
//               <label>Pant Size:</label>
//               <div className="form-control" style={{ padding: 0 }}>
//                 <select
//                   multiple
//                   value={bottomSize}
//                   onChange={(e) =>
//                     setBottomSize([...e.target.selectedOptions].map((o) => o.value))
//                   }
//                   style={SELECT_INNER}
//                 >
//                   {pantSizes.map((sz, i) => (
//                     <option key={i} value={sz.size}>
//                       {sz.category} {sz.label} ({sz.range})
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//           </>
//         )}

//         {type === "shoes" && (
//           <div className="form-group">
//             <label>Shoe Size:</label>
//             <div className="form-control" style={{ padding: 0 }}>
//               <select
//                 multiple
//                 value={shoeSize}
//                 onChange={(e) =>
//                   setShoeSize([...e.target.selectedOptions].map((o) => o.value))
//                 }
//                 style={SELECT_INNER}
//               >
//                 {Array.from({ length: 10 }, (_, i) => (i + 6) + 0.5).map((sz) => (
//                   <option key={sz} value={sz}>
//                     {sz}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>
//         )}

//         {/* ✅ RESTORED: Local previews (if any) */}
//         {imagePaths.length > 0 && (
//           <div
//             className="preview-container"
//             style={{ display: "flex", flexWrap: "wrap", marginTop: 10 }}
//           >
//             {imagePaths.map((src, i) => (
//               <img
//                 key={i}
//                 src={src}
//                 alt={`Preview ${i}`}
//                 style={{ width: 100, marginRight: 5, marginBottom: 5 }}
//               />
//             ))}
//           </div>
//         )}
//       </form>

//       {/* Media gallery */}
//       <h3 style={{ ...FORM_WIDTH, marginTop: 12 }}>Media</h3>
//       {itemMedia.length > 0 ? (
//         <div className="feed" style={{ padding: 0 }}>
//           {itemMedia.map((m, idx) => (
//             <article
//               key={`media-${idx}`}
//               className="feed-card"
//               style={{
//                 padding: 0,
//                 border: "1px solid rgba(0,0,0,0.15)",
//                 borderRadius: 12,
//                 overflow: "hidden",
//               }}
//             >
//               {/* Media display */}
//               {m.isVideo ? (
//                 <video
//                   className="feed-media"
//                   src={m.url}
//                   controls
//                   preload="metadata"
//                   playsInline
//                   {...videoFixProps}
//                 />
//               ) : (
//                 <img
//                   className="feed-media"
//                   src={m.url}
//                   alt=""
//                   onError={(e) => (e.currentTarget.src = toAbs(baseUrl, "/public/app/default-image.png"))}
//                 />
//               )}

//               {/* Controls BELOW the media */}
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   padding: "8px 12px",
//                   background: "rgba(255,255,255,0.96)",
//                   borderTop: "1px solid rgba(0,0,0,0.08)",
//                 }}
//               >
//                 <label className="flex items-center gap-2 text-sm">
//                   <input
//                     type="checkbox"
//                     checked={!!selectedMedia[m.url]}
//                     onChange={() => toggleSelect(m.url)}
//                     style={{ width: 16, height: 16 }}
//                   />
//                   Select
//                 </label>
//                 <button
//                   type="button"
//                   aria-label="Delete item media"
//                   onClick={() => handleDeleteItemMedia(m.url)}
//                   className="btn btn-sm btn-outline"
//                   style={{ width: "auto" }}
//                 >
//                   Delete
//                 </button>
//               </div>
//             </article>
//           ))}
//         </div>
//       ) : (
//         <p style={FORM_WIDTH}>No media available for this event item.</p>
//       )}

//       {/* Action Type + button — match EventAdd width */}
//       <div style={{ ...FORM_WIDTH, marginTop: 12 }}>
//         <div className="toggle-group">
//           <label className="block mb-2 font-semibold">Action Type:</label>
//           <ToggleButtonGroup
//             options={[
//               { value: "default", label: "Default" },
//               { value: "auction", label: "Auction" },
//               { value: "raffle", label: "Raffle" },
//             ]}
//             value={actionType}
//             onChange={setActionType}
//           />
//         </div>

//         {canCreateAction && (
//           <button
//             type="button"
//             className="btn btn-primary mt-3"
//             onClick={goToActionSetup}
//           >
//             {actionType.toLowerCase() === "raffle"
//               ? "Create Raffle"
//               : "Configure Auction"}
//           </button>
//         )}
//       </div>

//       {registerStatus && (
//         <p className="status-message" style={FORM_WIDTH}>
//           {registerStatus}
//         </p>
//       )}

//       {/* Auction/Raffle Config Modals */}
//       {showAuctionConfig && (
//         <AuctionConfig 
//           tenantId={tenant}
//           eventId={eventId}
//           itemId={itemId}
//           itemName={name}
//           onClose={() => setShowAuctionConfig(false)}
//         />
//       )}

//       {showRaffleConfig && (
//         <RaffleConfig 
//           tenantId={tenant}
//           eventId={eventId}
//           itemId={itemId}
//           itemName={name}
//           onClose={() => setShowRaffleConfig(false)}
//         />
//       )}

//       {/* Comments — match EventAdd width/placement */}
//       <div style={{ ...FORM_WIDTH, marginTop: 12 }}>
//         <CommentsPanel
//           baseUrl={baseUrl}
//           tenantId={tenant}
//           eventId={eventId}
//           itemId={itemId}
//         />
//       </div>

//       {raffleLink && (
//         <div
//           className="rounded p-2 mb-2"
//           style={{ ...FORM_WIDTH, background: "#1f2937", color: "#fff", marginTop: 12 }}
//         >
//           <div className="flex items-center justify-between gap-2">
//             <span className="truncate">{raffleLink}</span>
//             <button
//               type="button"
//               className="btn btn-sm"
//               onClick={() => navigator.clipboard?.writeText?.(raffleLink)}
//             >
//               Copy Link
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Modals */}
//       {showCamera && (
//         <CameraComponent
//           onImageCaptured={handleImageCaptured}
//           onClose={() => setShowCamera(false)}
//         />
//       )}

//       {isImageModalOpen && (
//         <ImageUploadModal
//           tenantId={tenant}
//           imageName={`${Date.now()}_${tenant}_${name}`}
//           onUploadComplete={handleUploadComplete}
//           onClose={() => setIsImageModalOpen(false)}
//         />
//       )}

//       {/* Footer with dynamic buttons based on selection */}
//       <AppFooter
//         buttons={[
//           {
//             icon: <FaArrowLeft />,
//             label: "Back",
//             onClick: () => navigate(-1),
//           },
//           { 
//             icon: <FaCamera />, 
//             label: "Take Photo", 
//             onClick: () => setShowCamera(true) 
//           },
//           { 
//             icon: <FaUpload />, 
//             label: "Upload Photo", 
//             onClick: () => setIsImageModalOpen(true) 
//           },
//           // Show "Post (X)" when media selected, otherwise "Post"
//           ...(selectedCount > 0 ? [{
//             icon: <FaShare />,
//             label: `Post (${selectedCount})`,
//             onClick: () => setPostChoiceOpen(true),
//           }] : [{
//             icon: <FaShare />,
//             label: "Post",
//             onClick: () => setPostChoiceOpen(true),
//           }]),
//           // Show "Delete (X)" button when media is selected
//           ...(selectedCount > 0 ? [{
//             icon: <FaTrash />,
//             label: `Delete (${selectedCount})`,
//             onClick: handleDeleteSelected,
//           }] : []),
//           ...(canCreateAction ? [{
//             icon: <FaPlus />, 
//             label: "Create", 
//             onClick: goToActionSetup 
//           }] : []),
//         ]}
//       />

//       {/* Post Choice Modal */}
//       {postChoiceOpen && (
//         <PostChoiceModal
//           isOpen={postChoiceOpen}
//           onClose={() => setPostChoiceOpen(false)}
//           title={selectedCount > 0 ? "Post Selected Media" : "Item Post"}
//           hint={selectedCount > 0 
//             ? `Post ${selectedCount} selected media item(s) now or schedule a post.` 
//             : "Post now (opens your full post flow) or schedule a post."}
//           onPostNow={() => {
//             setPostChoiceOpen(false);
//             // Post selected media if any selected, otherwise post all
//             if (selectedCount > 0) {
//               handlePostSelected();
//             } else {
//               handleCreateMediaPost();
//             }
//           }}
//           onSchedule={() => {
//             setPostChoiceOpen(false);
            
//             if (selectedCount > 0) {
//               // Schedule with ONLY selected media
//               const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);
//               const toPublic = (p) => (p?.startsWith("/public/") ? p : p?.startsWith("/tenants/") ? `/public${p}` : p);
              
//               const selectedImages = [];
//               const selectedVideos = [];

//               eventItemImages.forEach((img) => {
//                 const url = toAbs(baseUrl, img.path || img.url || img);
//                 if (selectedUrls.includes(url)) {
//                   selectedImages.push(toPublic(img.path || img.url || img));
//                 }
//               });

//               eventItemVideos.forEach((vid) => {
//                 const url = toAbs(baseUrl, vid.path || vid.url || vid);
//                 if (selectedUrls.includes(url)) {
//                   selectedVideos.push(toPublic(vid.path || vid.url || vid));
//                 }
//               });

//               navigate(`/${tenant}/${eventId}/${itemId}/schedulePost`, {
//                 state: {
//                   context: "event-item",
//                   tenant,
//                   eventId,
//                   itemId,
//                   title: name || "",
//                   description: description || "",
//                   image: selectedImages[0] || "",
//                   images: selectedImages,
//                   videos: selectedVideos,
//                   item: eventItem,
//                 },
//               });
//             } else {
//               // Schedule with ALL media
//               const toPublic = (p) => (p?.startsWith("/public/") ? p : p?.startsWith("/tenants/") ? `/public${p}` : p);
//               const cover = eventItemImages?.[0]?.path || "";
              
//               navigate(`/${tenant}/${eventId}/${itemId}/schedulePost`, {
//                 state: {
//                   context: "event-item",
//                   tenant,
//                   eventId,
//                   itemId,
//                   title: name || "",
//                   description: description || "",
//                   image: toPublic(cover),
//                   images: (eventItemImages || []).map((i) => toPublic(i.path)),
//                   videos: (eventItemVideos || []).map((v) => toPublic(v.path)),
//                   item: eventItem,
//                 },
//               });
//             }
//           }}
//         />
//       )}
//     </div>
//   );
// };

// export default EventItemDetail;


// client/src/components/events/EventItemDetail.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import ImageUploadModal from "../media/ImageUploadModal";
import CameraComponent from "../media/CameraComponent";
import AppFooter from "../AppFooter";
import { useWebShare } from "../../hooks/useWebShare";
import { FaCamera, FaUpload, FaTimes, FaPlus, FaShare, FaEnvelope, FaArrowLeft, FaTrash } from "react-icons/fa";
import CommentsPanel from "../comments/CommentsPanel";
import ToggleButtonGroup from "../ToggleButtonGroup";
import { useMessagesUI } from "../../context/MessagesContext";
import PostChoiceModal from "../media/PostChoiceModal";
import AuctionConfig from "./AuctionConfig";
import RaffleConfig from "./RaffleConfig";
import ConfirmDeleteModal from "../../modals/ConfirmDeleteModal";

// ---- helpers kept in sync with EventCard ----
const toAbs = (baseUrl, p) =>
  !p ? p : /^https?:\/\//i.test(p) ? p : `${baseUrl}${p.startsWith("/") ? "" : "/"}${p}`;
const isImage = (f) =>
  (f?.mimetype?.startsWith?.("image/")) ||
  /\.(png|jpe?g|gif|webp|svg|bmp)$/i.test(f?.path || f || "");
const isVideo = (f) =>
  (f?.mimetype?.startsWith?.("video/")) ||
  /\.(mp4|mov|webm|ogg|avi|mkv)$/i.test(f?.path || f || "");

// Video fix props for Safari/iOS
const videoFixProps = {
  playsInline: true,
  preload: "metadata",
  crossOrigin: "anonymous",
  onLoadedMetadata: (e) => {
    try {
      if (e.currentTarget.currentTime === 0) e.currentTarget.currentTime = 0.1;
    } catch {}
  },
};

// ---- layout: match EventAdd ----
const FORM_WIDTH = { maxWidth: 480, margin: "0 auto", padding: "0 12px" };
const SELECT_INNER = {
  width: "100%",
  border: "none",
  outline: "none",
  background: "transparent",
  minHeight: 120,
  padding: "8px 10px",
};

const EventItemDetail = () => {
  const [type, setType] = useState("default");
  const [actionType, setActionType] = useState("default");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [topSize, setTopSize] = useState([]);
  const [bottomSize, setBottomSize] = useState([]);
  const [shoeSize, setShoeSize] = useState([]);
  const [files, setFiles] = useState([]);
  const [registerStatus, setRegisterStatus] = useState("");
  const [imagePath, setImagePath] = useState(null);
  const [imagePaths, setImagePaths] = useState([]);
  const [showCamera, setShowCamera] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [postChoiceOpen, setPostChoiceOpen] = useState(false);
  const [raffleLink, setRaffleLink] = useState("");
  
  const [showAuctionConfig, setShowAuctionConfig] = useState(false);
  const [showRaffleConfig, setShowRaffleConfig] = useState(false);

  const [eventItem, setEventItem] = useState(null);
  const [eventItemImages, setEventItemImages] = useState([]);
  const [eventItemVideos, setEventItemVideos] = useState([]);
  const [selectedMedia, setSelectedMedia] = useState({}); // { [url]: true }

  const navigate = useNavigate();
  const { tenant, eventId, itemId } = useParams();
  const { share } = useWebShare();
  const { openMessages } = useMessagesUI();

  const baseUrl =
    process.env.REACT_APP_BASE_URL ||
    (typeof window !== "undefined" ? window.location.origin : "http://localhost:5000");

  // unified media list
  const rawItemFiles = [
    ...(Array.isArray(eventItem?.files) ? eventItem.files : []),
    ...(eventItemImages || []),
    ...(eventItemVideos || []),
  ].filter(Boolean);

  const itemMedia = rawItemFiles
    .map((f) => {
      const path = f?.path || f?.url || f;
      const video = isVideo(f) || isVideo(path);
      return { url: toAbs(baseUrl, path), isVideo: !!video, _raw: f };
    })
    .filter((m, idx, arr) => arr.findIndex((x) => x.url === m.url) === idx);

  // Count selected media
  const selectedCount = Object.values(selectedMedia).filter(Boolean).length;

  const pantSizes = [
    { category: "M", range: "26 - 27", size: 26, label: "XXS" },
    { category: "M", range: "27 - 28", size: 27, label: "XS" },
    { category: "M", range: "28 - 29", size: 28, label: "XS" },
    { category: "M", range: "29 - 30", size: 29, label: "S" },
    { category: "M", range: "30 - 31", size: 30, label: "S" },
    { category: "M", range: "31 - 32", size: 31, label: "M" },
    { category: "M", range: "32 - 33", size: 32, label: "M" },
    { category: "M", range: "33 - 34", size: 33, label: "M/L" },
    { category: "M", range: "34 - 35", size: 34, label: "L" },
    { category: "M", range: "35 - 36", size: 35, label: "L" },
    { category: "M", range: "36 - 37", size: 36, label: "XL" },
    { category: "M", range: "38 - 39", size: 38, label: "XL" },
    { category: "M", range: "40 - 41", size: 40, label: "XXL" },
    { category: "M", range: "42 - 43", size: 42, label: "XXL" },
    { category: "M", range: "44 - 45", size: 44, label: "XXXL" },
    { category: "M", range: "46 - 47", size: 46, label: "XXXL" },
    { category: "M", range: "48 - 49", size: 48, label: "XXXL" },
    { category: "M", range: "50 - 51", size: 50, label: "4XL" },
    { category: "W", range: "23 - 25", size: "00", altSize: "23/24", label: "XXS" },
    { category: "W", range: "25 - 26", size: "0", altSize: "25", label: "XXS" },
    { category: "W", range: "26 - 27", size: "2", altSize: "26", label: "XS" },
    { category: "W", range: "27 - 28", size: "4", altSize: "27", label: "XS" },
    { category: "W", range: "28 - 29", size: "6", altSize: "28", label: "S" },
    { category: "W", range: "29 - 30", size: "8", altSize: "29", label: "S" },
    { category: "W", range: "30 - 31", size: "10", altSize: "30", label: "M" },
    { category: "W", range: "31 - 32", size: "12", altSize: "31", label: "M" },
    { category: "W", range: "32 - 33", size: "14", altSize: "32", label: "L" },
    { category: "W", range: "33 - 34", size: "16", altSize: "33", label: "L" },
    { category: "W", range: "34 - 35", size: "18", altSize: "34", label: "XL" },
    { category: "W", range: "36 - 37", size: "20", altSize: "36", label: "XL" },
    { category: "W", range: "38 - 39", size: "22", altSize: "38", label: "XXL" },
    { category: "W", range: "40 - 41", size: "24", altSize: "40", label: "XXL" },
  ];

  const canCreateAction = ["raffle", "auction"].includes((actionType || "").toLowerCase());

  const goToActionSetup = () => {
    const act = (actionType || "").toLowerCase();
    if (act === "auction") {
      setShowAuctionConfig(true);
    } else if (act === "raffle") {
      setShowRaffleConfig(true);
    }
  };

  // Load item + its media
  useEffect(() => {
    const fetchItemDetails = async () => {
      try {
        const [itemRes, imagesRes] = await Promise.all([
          axios.get(`${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}`),
          axios.get(`${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/images`),
        ]);

        const itemData = itemRes.data.item || {};
        setEventItem(itemData);
        setName(itemData.name || "");
        setDescription(itemData.description || "");
        setType(itemData.type || "default");

        if (itemData.attributes) {
          const top = itemData.attributes.filter((a) => a.attributename === "top_size").map((a) => a.attributevalue);
          const bottom = itemData.attributes.filter((a) => a.attributename === "bottom_size").map((a) => a.attributevalue);
          const shoes = itemData.attributes.filter((a) => a.attributename === "shoe_size").map((a) => a.attributevalue);
          setTopSize(top);
          setBottomSize(bottom);
          setShoeSize(shoes);
        }

        setEventItemImages(imagesRes.data.images || []);

        try {
          const vidsRes = await axios.get(
            `${baseUrl}/api/${tenant}/events/${eventId}/items/${itemId}/videos`
          );
          setEventItemVideos(vidsRes.data.videos || []);
        } catch {
          setEventItemVideos([]);
        }
      } catch (error) {
        console.error("Error fetching event item details:", error);
      }
    };
    fetchItemDetails();
  }, [tenant, eventId, itemId, baseUrl]);

  const handleImageCaptured = (capturedImage) => {
    setImagePath(capturedImage);
    setShowCamera(false);
  };

  const handleUploadComplete = async (files) => {
    try {
      if (files.length === 0) return;
      setFiles(files);
      setImagePath(URL.createObjectURL(files[0]));
      setIsImageModalOpen(false);

      const formData = new FormData();
      formData.append("reftable", "t_event_item");
      formData.append("tableid", itemId);
      files.forEach((file) => formData.append("files", file));

      try {
        const response = await axios.post(
          `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/uploadimage`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        if (response.data.success) {
          const { data } = await axios.get(
            `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/images`
          );
          setEventItemImages(data?.images || []);
        }
      } catch (error) {
        console.error("❌ Error uploading images:", error);
      }
      setRegisterStatus("Files uploaded successfully!");
    } catch (error) {
      console.error("Error linking uploaded files:", error);
    }
  };

  useEffect(() => {
    document.body.classList.add("eventlist-fullbleed");
    return () => document.body.classList.remove("eventlist-fullbleed");
  }, []);

  // Messages
  useEffect(() => {
    axios
      .get(`${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/messages`)
      .then((res) => setMessages(Array.isArray(res.data) ? res.data : res.data?.messages || []))
      .catch((err) => console.error("Error loading messages:", err));
  }, [tenant, eventId, itemId, baseUrl]);

  const sendMessage = async () => {
    if (!newMessage.trim()) return;
    let currentUser = null;
    try { currentUser = JSON.parse(localStorage.getItem("user")); } catch {}
    const payload = { text: newMessage, senderId: currentUser?.id, username: currentUser?.username, email: currentUser?.email };
    try {
      const res = await axios.post(
        `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/messages`,
        payload
      );
      setMessages((m) => [...m, res.data]);
      setNewMessage("");
    } catch (err) {
      console.error("Error sending message:", err);
    }
  };

  const updateItem = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}`,
        { name, description, type, topSize, bottomSize, shoeSize }
      );
      navigate(`/${tenant}/${eventId}/eventDetail`);
    } catch (err) {
      console.error("Failed to update item:", err);
    }
  };

  const handleCancel = () => navigate(`/${tenant}/events`);

  /**
   * Post ALL media (when no selection)
   */
  const handleCreateMediaPost = () => {
    const toPublic = (p) => (p?.startsWith("/public/") ? p : p?.startsWith("/tenants/") ? `/public${p}` : p);
    const cover = toPublic(eventItemImages?.[0]?.path || "");
    navigate(`/${tenant}/${eventId}/${itemId}/mediaPost`, {
      state: {
        context: "event-item",
        tenant,
        eventId,
        itemId,
        title: name || "",
        description: description || "",
        image: cover,
        images: (eventItemImages || []).map((i) => toPublic(i.path)),
        videos: (eventItemVideos || []).map((v) => toPublic(v.path)),
        item: eventItem,
      },
      replace: false,
    });
  };

  /**
   * Post ONLY selected media
   */
  const handlePostSelected = () => {
    const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);
    
    if (selectedUrls.length === 0) {
      alert("Please select at least one media item to post.");
      return;
    }

    const toPublic = (p) => (p?.startsWith("/public/") ? p : p?.startsWith("/tenants/") ? `/public${p}` : p);

    const selectedImages = [];
    const selectedVideos = [];

    // Collect selected images
    eventItemImages.forEach((img) => {
      const url = toAbs(baseUrl, img.path || img.url || img);
      if (selectedUrls.includes(url)) {
        selectedImages.push(toPublic(img.path || img.url || img));
      }
    });

    // Collect selected videos
    eventItemVideos.forEach((vid) => {
      const url = toAbs(baseUrl, vid.path || vid.url || vid);
      if (selectedUrls.includes(url)) {
        selectedVideos.push(toPublic(vid.path || vid.url || vid));
      }
    });

    const cover = selectedImages[0] || "";

    navigate(`/${tenant}/${eventId}/${itemId}/mediaPost`, {
      state: {
        context: "event-item",
        tenant,
        eventId,
        itemId,
        title: name || "",
        description: description || "",
        image: cover,
        images: selectedImages,
        videos: selectedVideos,
        item: eventItem,
      },
      replace: false,
    });
  };

  const toggleSelect = (url) =>
    setSelectedMedia((prev) => ({ ...prev, [url]: !prev[url] }));
  
  // Delete confirmation modal state
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  /**
   * Delete single item media - WITH BACKEND INTEGRATION
   */
  const handleDeleteItemMedia = async (url) => {
    if (!window.confirm("Delete this item media?")) return;
    
    try {
      // Call backend API to delete the item media
      const response = await axios.delete(
        `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/media/single`,
        { data: { url } }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to delete item media');
      }

      // Update UI state after successful deletion
      setEventItemImages((prev) => (prev || []).filter((x) => toAbs(baseUrl, x.path || x.url || x) !== url));
      setEventItemVideos((prev) => (prev || []).filter((x) => toAbs(baseUrl, x.path || x.url || x) !== url));
      setSelectedMedia((prev) => {
        const n = { ...prev };
        delete n[url];
        return n;
      });

    } catch (error) {
      console.error("Error deleting item media:", error);
      alert(`Failed to delete item media: ${error.message || 'Unknown error'}. Please try again.`);
    }
  };

  /**
   * Delete selected media (batch) - Shows confirmation modal
   */
  const handleDeleteSelected = () => {
    const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);
    
    if (selectedUrls.length === 0) {
      alert("Please select at least one media item to delete.");
      return;
    }

    // Show confirmation modal instead of window.confirm
    setShowDeleteModal(true);
  };

  /**
   * Perform the actual deletion after confirmation
   */
  const performDelete = async () => {
    const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);

    try {
      // Call backend API for batch deletion
      const response = await axios.delete(
        `${baseUrl}/api/events/${tenant}/events/${eventId}/items/${itemId}/media`,
        { data: { urls: selectedUrls } }
      );
      
      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to delete media');
      }

      // Update UI state after successful deletion
      setEventItemImages((prev) => 
        (prev || []).filter((x) => !selectedUrls.includes(toAbs(baseUrl, x.path || x.url || x)))
      );
      setEventItemVideos((prev) => 
        (prev || []).filter((x) => !selectedUrls.includes(toAbs(baseUrl, x.path || x.url || x)))
      );

      // Clear selection
      setSelectedMedia({});

    } catch (error) {
      console.error("Error deleting selected media:", error);
      alert(`Failed to delete media: ${error.message || 'Unknown error'}. Please try again.`);
    }
  };

  return (
    <div className="container">
      <h2 className="hdr hdr--primary hdr--lg">Event Item Detail</h2>

      {/* Selected media count indicator */}
      {selectedCount > 0 && (
        <div
          style={{
            ...FORM_WIDTH,
            padding: "8px 12px",
            margin: "8px auto",
            background: "#ff6800",
            color: "white",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "600",
          }}
        >
          {selectedCount} media item{selectedCount !== 1 ? "s" : ""} selected
        </div>
      )}

      {/* FORM — match EventAdd width */}
      <form onSubmit={updateItem} style={FORM_WIDTH}>
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            id="name"
            type="text"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter item name"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="description">Description</label>
          <textarea
            id="description"
            className="form-control"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter item description"
          />
        </div>

        <div className="toggle-group">
          <label className="block mb-2 font-semibold">Select Item Type:</label>
          <ToggleButtonGroup
            options={["default", "clothing", "shoes"]}
            value={type}
            onChange={setType}
          />
        </div>

        {type === "clothing" && (
          <>
            <div className="form-group">
              <label>Shirt Size:</label>
              <div className="form-control" style={{ padding: 0 }}>
                <select
                  multiple
                  value={topSize}
                  onChange={(e) =>
                    setTopSize([...e.target.selectedOptions].map((o) => o.value))
                  }
                  style={SELECT_INNER}
                >
                  {[
                    "Extra Small",
                    "Small",
                    "Medium",
                    "Large",
                    "X-Large",
                    "2X-Large",
                    "3X-Large",
                  ].map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-group">
              <label>Pant Size:</label>
              <div className="form-control" style={{ padding: 0 }}>
                <select
                  multiple
                  value={bottomSize}
                  onChange={(e) =>
                    setBottomSize([...e.target.selectedOptions].map((o) => o.value))
                  }
                  style={SELECT_INNER}
                >
                  {pantSizes.map((sz, i) => (
                    <option key={i} value={sz.size}>
                      {sz.category} {sz.label} ({sz.range})
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </>
        )}

        {type === "shoes" && (
          <div className="form-group">
            <label>Shoe Size:</label>
            <div className="form-control" style={{ padding: 0 }}>
              <select
                multiple
                value={shoeSize}
                onChange={(e) =>
                  setShoeSize([...e.target.selectedOptions].map((o) => o.value))
                }
                style={SELECT_INNER}
              >
                {Array.from({ length: 10 }, (_, i) => (i + 6) + 0.5).map((sz) => (
                  <option key={sz} value={sz}>
                    {sz}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        {/* ✅ RESTORED: Local previews (if any) */}
        {imagePaths.length > 0 && (
          <div
            className="preview-container"
            style={{ display: "flex", flexWrap: "wrap", marginTop: 10 }}
          >
            {imagePaths.map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`Preview ${i}`}
                style={{ width: 100, marginRight: 5, marginBottom: 5 }}
              />
            ))}
          </div>
        )}
      </form>

      {/* Media gallery */}
      <h3 style={{ ...FORM_WIDTH, marginTop: 12 }}>Media</h3>
      {itemMedia.length > 0 ? (
        <div className="feed" style={{ padding: 0 }}>
          {itemMedia.map((m, idx) => (
            <article
              key={`media-${idx}`}
              className="feed-card"
              style={{
                padding: 0,
                border: "1px solid rgba(0,0,0,0.15)",
                borderRadius: 12,
                overflow: "hidden",
              }}
            >
              {/* Media display */}
              {m.isVideo ? (
                <video
                  className="feed-media"
                  src={m.url}
                  controls
                  preload="metadata"
                  playsInline
                  {...videoFixProps}
                />
              ) : (
                <img
                  className="feed-media"
                  src={m.url}
                  alt=""
                  onError={(e) => (e.currentTarget.src = toAbs(baseUrl, "/public/app/default-image.png"))}
                />
              )}

              {/* Controls BELOW the media */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "8px 12px",
                  // background: "rgba(255,255,255,0.96)",
                  background: "#01057a",
                  borderTop: "1px solid rgba(0,0,0,0.08)",
                }}
              >
                <label className="flex items-center gap-2 text-sm">
                  <input
                    type="checkbox"
                    checked={!!selectedMedia[m.url]}
                    onChange={() => toggleSelect(m.url)}
                    style={{ width: 16, height: 16 }}
                  />
                  Select
                </label>

              </div>
            </article>
          ))}
        </div>
      ) : (
        <p style={FORM_WIDTH}>No media available for this event item.</p>
      )}

      {/* Action Type + button — match EventAdd width */}
      <div style={{ ...FORM_WIDTH, marginTop: 12 }}>
        <div className="toggle-group">
          <label className="block mb-2 font-semibold">Action Type:</label>
          <ToggleButtonGroup
            options={[
              { value: "default", label: "Default" },
              { value: "auction", label: "Auction" },
              { value: "raffle", label: "Raffle" },
            ]}
            value={actionType}
            onChange={setActionType}
          />
        </div>

        {canCreateAction && (
          <button
            type="button"
            className="btn btn-primary mt-3"
            onClick={goToActionSetup}
          >
            {actionType.toLowerCase() === "raffle"
              ? "Create Raffle"
              : "Configure Auction"}
          </button>
        )}
      </div>

      {registerStatus && (
        <p className="status-message" style={FORM_WIDTH}>
          {registerStatus}
        </p>
      )}

      {/* Auction/Raffle Config Modals */}
      {showAuctionConfig && (
        <AuctionConfig 
          tenantId={tenant}
          eventId={eventId}
          itemId={itemId}
          itemName={name}
          onClose={() => setShowAuctionConfig(false)}
        />
      )}

      {showRaffleConfig && (
        <RaffleConfig 
          tenantId={tenant}
          eventId={eventId}
          itemId={itemId}
          itemName={name}
          onClose={() => setShowRaffleConfig(false)}
        />
      )}

      {/* Comments — match EventAdd width/placement */}
      <div style={{ ...FORM_WIDTH, marginTop: 12 }}>
        <CommentsPanel
          baseUrl={baseUrl}
          tenantId={tenant}
          eventId={eventId}
          itemId={itemId}
        />
      </div>

      {raffleLink && (
        <div
          className="rounded p-2 mb-2"
          style={{ ...FORM_WIDTH, background: "#1f2937", color: "#fff", marginTop: 12 }}
        >
          <div className="flex items-center justify-between gap-2">
            <span className="truncate">{raffleLink}</span>
            <button
              type="button"
              className="btn btn-sm"
              onClick={() => navigator.clipboard?.writeText?.(raffleLink)}
            >
              Copy Link
            </button>
          </div>
        </div>
      )}

      {/* Modals */}
      {showCamera && (
        <CameraComponent
          onImageCaptured={handleImageCaptured}
          onClose={() => setShowCamera(false)}
        />
      )}

      {isImageModalOpen && (
        <ImageUploadModal
          tenantId={tenant}
          imageName={`${Date.now()}_${tenant}_${name}`}
          onUploadComplete={handleUploadComplete}
          onClose={() => setIsImageModalOpen(false)}
        />
      )}

      {/* Footer with dynamic buttons based on selection */}
      <AppFooter
        buttons={[
          {
            icon: <FaArrowLeft />,
            label: "Back",
            onClick: () => navigate(-1),
          },
          { 
            icon: <FaCamera />, 
            label: "Take Photo", 
            onClick: () => setShowCamera(true) 
          },
          { 
            icon: <FaUpload />, 
            label: "Upload Photo", 
            onClick: () => setIsImageModalOpen(true) 
          },
          // Show "Post (X)" when media selected, otherwise "Post"
          ...(selectedCount > 0 ? [{
            icon: <FaShare />,
            label: `Post (${selectedCount})`,
            onClick: () => setPostChoiceOpen(true),
          }] : [{
            icon: <FaShare />,
            label: "Post",
            onClick: () => setPostChoiceOpen(true),
          }]),
          // Show "Delete (X)" button when media is selected
          ...(selectedCount > 0 ? [{
            icon: <FaTrash />,
            label: `Delete (${selectedCount})`,
            onClick: handleDeleteSelected,
          }] : []),
          ...(canCreateAction ? [{
            icon: <FaPlus />, 
            label: "Create", 
            onClick: goToActionSetup 
          }] : []),
        ]}
      />

      {/* Confirm Delete Modal */}
      <ConfirmDeleteModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={performDelete}
        count={Object.values(selectedMedia).filter(Boolean).length}
        context="event-item"
      />

      {/* Post Choice Modal */}
      {postChoiceOpen && (
        <PostChoiceModal
          isOpen={postChoiceOpen}
          onClose={() => setPostChoiceOpen(false)}
          title={selectedCount > 0 ? "Post Selected Media" : "Item Post"}
          hint={selectedCount > 0 
            ? `Post ${selectedCount} selected media item(s) now or schedule a post.` 
            : "Post now (opens your full post flow) or schedule a post."}
          onPostNow={() => {
            setPostChoiceOpen(false);
            // Post selected media if any selected, otherwise post all
            if (selectedCount > 0) {
              handlePostSelected();
            } else {
              handleCreateMediaPost();
            }
          }}
          onSchedule={() => {
            setPostChoiceOpen(false);
            
            if (selectedCount > 0) {
              // Schedule with ONLY selected media
              const selectedUrls = Object.keys(selectedMedia).filter((url) => selectedMedia[url]);
              const toPublic = (p) => (p?.startsWith("/public/") ? p : p?.startsWith("/tenants/") ? `/public${p}` : p);
              
              const selectedImages = [];
              const selectedVideos = [];

              eventItemImages.forEach((img) => {
                const url = toAbs(baseUrl, img.path || img.url || img);
                if (selectedUrls.includes(url)) {
                  selectedImages.push(toPublic(img.path || img.url || img));
                }
              });

              eventItemVideos.forEach((vid) => {
                const url = toAbs(baseUrl, vid.path || vid.url || vid);
                if (selectedUrls.includes(url)) {
                  selectedVideos.push(toPublic(vid.path || vid.url || vid));
                }
              });

              navigate(`/${tenant}/${eventId}/${itemId}/schedulePost`, {
                state: {
                  context: "event-item",
                  tenant,
                  eventId,
                  itemId,
                  title: name || "",
                  description: description || "",
                  image: selectedImages[0] || "",
                  images: selectedImages,
                  videos: selectedVideos,
                  item: eventItem,
                },
              });
            } else {
              // Schedule with ALL media
              const toPublic = (p) => (p?.startsWith("/public/") ? p : p?.startsWith("/tenants/") ? `/public${p}` : p);
              const cover = eventItemImages?.[0]?.path || "";
              
              navigate(`/${tenant}/${eventId}/${itemId}/schedulePost`, {
                state: {
                  context: "event-item",
                  tenant,
                  eventId,
                  itemId,
                  title: name || "",
                  description: description || "",
                  image: toPublic(cover),
                  images: (eventItemImages || []).map((i) => toPublic(i.path)),
                  videos: (eventItemVideos || []).map((v) => toPublic(v.path)),
                  item: eventItem,
                },
              });
            }
          }}
        />
      )}
    </div>
  );
};

export default EventItemDetail;